<script setup>
import { onMounted } from 'vue'
import VideoPlayer from '../../VideoPlayer.vue'

const videoElement = ref(null)
const videoBackgroundElement = ref(null)

onMounted(async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true })
    videoElement.value.srcObject = stream
    videoBackgroundElement.value.srcObject = stream
  } catch (error) {
    console.error('Error accessing webcam:', error)
  }
})
</script>

<template>
  <VideoPlayer class="absolute z-20 top-0 left-0 w-full h-full" autoplay @videoElement="videoElement = $event" />
  <VideoPlayer class="absolute z-10 top-0 bottom-0 left-0 w-screen -translate-y-1/2 blur-3xl scale-110" autoplay @videoElement="videoBackgroundElement = $event" />
  <div class="w-full h-full absolute bg-black" />
</template>
